<app-loader *ngIf="isDisabled"></app-loader>
<form name="CompensatoryForm" (ngSubmit)="Validate(CompensatoryForm)" #CompensatoryForm="ngForm" class="pb-2">
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                Compensatory Off Consume Request
            </div>
        </div>
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter()">
                        <div class="row" style="line-height: 25px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #20C997; color: #fff;">
                                <i class="bi bi-people fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #F8F9FA; color: #20C997;">
                                <div class="m-1" style="font-size: medium; font-weight: 500;">
                                   Balance as on current Date
                                </div>
                                <div class="m-1 count" style="font-size: xx-large; font-weight: 400; line-height: 32px;">
                                    {{CompensatoryConsume.TotalCount}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
                <!-- <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer">
                        <div class="row" style="line-height: 30px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #FF6F61; color: #fff;">
                                <i class="bi bi-people fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #F1F1F1; color: #FF6F61;">
                                <div class="m-1" style="font-size: medium; font-weight: 500;">
                                    Available for Consume
                                </div>
                                <div class="m-1 count" style="font-size: xx-large; font-weight: 400; line-height: 32px;">
                                    {{CompensatoryConsume.TotalCount}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                             -->
            </div>
            <div class="row py-2">
                <div class="col-md-3">
                    <label for="LeaveFromDate" class="form-font-label">From Date<span
                            class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd mmm yyyy" name="LeaveFromDate"
                            [(ngModel)]="CompensatoryConsume.LeaveFromDateObj" ngbDatepicker
                            #LeaveFromDate="ngbDatepicker" required (ngModelChange)="Clear();NoOfDayCount()" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="LeaveFromDate.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="LeaveToDate" class="form-font-label">To Date<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd mmm yyyy" name="LeaveToDate"
                            [(ngModel)]="CompensatoryConsume.LeaveToDateObj" ngbDatepicker #LeaveToDate="ngbDatepicker"
                            required (ngModelChange)="Clear();NoOfDayCount()" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="LeaveToDate.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="BalanceCount" class="form-font-label">Balance Count<span class="text-danger">*</span></label>
                    <input type="number" class="form-control" placeholder="Ex. 1" id="BalanceCount" name="BalanceCount"
                        [(ngModel)]="CompensatoryConsume.BalanceCount" #BalanceCount="ngModel" required disabled>
                    <div class="invalid-feedback">
                        Please enter Balance Count!
                    </div>
                </div>
                <div class="col-md-auto" style="align-content: end;">
                    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Openpopup(2)">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'View History':'Loading...'}}</button>
                </div>
                
                <!-- <div class="col-md-auto" style="align-content: end;">
                    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Openpopup(1)">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Get':'Loading...'}}</button>
                </div> -->
            </div>
            <div class="row py-2">
                <div class="col-md-4" style="align-content: center;">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="HalfDay" name="HalfDay"
                            [(ngModel)]="CompensatoryConsume.HalfDay" (change)="NoOfDayCount()">
                        <label class="form-check-label" for="HalfDay">Half
                            Day</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="HalfDaySession" class="form-font-label">Half Day Session<span class="text-danger"
                            *ngIf="CompensatoryConsume.HalfDay">*</span></label>
                    <select class="form-select" aria-label="HalfDaySession" placeholder="HalfDaySession"
                        title="HalfDaySession" name="HalfDaySession" data-live-search="true"
                        [disabled]="!CompensatoryConsume.HalfDay" [(ngModel)]="CompensatoryConsume.HalfDaySession"
                        #HalfDaySession="ngModel" required>
                        <option disabled hidden [value]=null>--Select Half Day Session--</option>
                        @for (HalfDaySession of HalfDaySessions; track HalfDaySession.Value; let i =
                        $index)
                        {
                        <option [value]="HalfDaySession.Value">{{HalfDaySession.Name}}</option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select half day session!
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="NoOfDay" class="form-font-label">No Of Day<span class="text-danger">*</span></label>
                    <input type="number" class="form-control" placeholder="Ex. 1" id="NoOfDay" name="NoOfDay"
                        [(ngModel)]="CompensatoryConsume.NoOfDay" #NoOfDay="ngModel" required disabled>
                    <div class="invalid-feedback">
                        Please enter no of day!
                    </div>
                </div>
                <!-- <div class="col-md-4">
                    <label for="NoOfDay" class="form-font-label">No Of Day<span class="text-danger">*</span></label>
                    <input type="number" class="form-control" placeholder="Ex. 1" id="NoOfDay" name="NoOfDay"
                        [(ngModel)]="CompensatoryConsume.NoOfDay" #NoOfDay="ngModel" required disabled>
                    <div class="invalid-feedback">
                        Please enter no of day!
                    </div>
                </div> -->
            </div>
            <div class="row">
                <div class="col-md-8">
                    <label for="Reason" class="form-font-label">Reason</label>
                    <input type="text" class="form-control" placeholder="Ex. Work Load" id="Reason" name="Reason"
                        [(ngModel)]="CompensatoryConsume.Reason" #Reason="ngModel">
                    <div class="invalid-feedback">
                        Please enter reason!
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-pass"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>